import axios from 'axios'


const donemCreate = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_BASE_URL+'/api/v1/donem/create',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data: data,
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
        });
    return response;
};

export default donemCreate;